import { render, staticRenderFns } from "./VerticalSteps.vue?vue&type=template&id=29b40994&"
import script from "./VerticalSteps.vue?vue&type=script&lang=ts&"
export * from "./VerticalSteps.vue?vue&type=script&lang=ts&"
import style0 from "./VerticalSteps.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports